var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block block-rounded mb-4"},[_c('div',{staticClass:"block-header block-header-default"},[_c('h3',{staticClass:"block-title"},[_vm._v("\n      Upcoming Holidays\n    ")])]),_vm._v(" "),_c('div',{staticClass:"block-content"},[_c('p',{staticClass:"text-muted small mb-0"},[_vm._v("\n      Upcoming holidays coming soon\n    ")])])])
}]

export { render, staticRenderFns }